import { Box, Typography } from "@mui/material";
import ActiveLocationsTable from "./table";

const EmployeesShiftsPage = () => {
  return (
    <Box p={"30px"} data-testid="employees-shifts-page">
      <Typography
        mb={4}
        fontSize={"22px"}
        fontWeight={600}
        data-testid="employees-shifts-title"
      >
        Employees Shifts
      </Typography>
      <ActiveLocationsTable />
    </Box>
  );
};

export default EmployeesShiftsPage;
